export default "__VITE_ASSET__NQsNg17$__"